import axios from 'axios';

const loadAbort = () => {
    return new AbortController();
};

export const getNearByPlaceDetailsEndpoint = (nearByPlaceId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/pre-sales/v1/admin/near-by-places/${nearByPlaceId}`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};

export const updateNearByPlaceAvatarEndpoint = (
    nearByPlaceId: string,
    form: any,
    token: string,
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/pre-sales/v1/admin/near-by-places/${nearByPlaceId}/upload-avatar`,
                data: form,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};

export const updateNearByPlaceGpsEndpoint = (
    nearByPlaceId: string,
    payload: { name: string; lat: number; lng: number },
    token: string,
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/pre-sales/v1/admin/near-by-places/${nearByPlaceId}`,
                data: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};

export const getNearByPlaceByIdEndpoint =(
    nearByPlaceId: string,
    token: string,
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/pre-sales/v1/admin/near-by-places/${nearByPlaceId}`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};